import React, { useState } from 'react';
import { useDispatch } from "react-redux";
import { openModals } from "../../redux/modal.slice";
import ModalsEnum from "../../enums/modal.enum";
import Button from "../Button";
import { QuestionImage } from "../../assets/imageAssets";
import { ArrowUpRight } from '@untitledui/icons/ArrowUpRight';
import { Image01 } from '@untitledui/icons/Image01';

const QuestionCard = ({question, answer, id, image, categoryTitle}) => {
    const dispatch = useDispatch();
    const [more, setMore] = useState(false);
    const [seeImage, setSeeImage] = useState(false);
    
    const handleSeeMore =() => {
        setMore(!more);
    }
    const openGenerateYourQuizModal = () => {
        dispatch(
            openModals({
                modalIds: [ModalsEnum.GENERATE_YOUR_QUIZ_MODAL],
                modalData: [
                    { 
                        id: id,
                        categoryTitle: categoryTitle
                    }
                ]
            })
        );
    }
    const seeCapturedImage = () => {
        setSeeImage(true);
    }

    return (
        <div className={`question-card flex ${more ? 'open' : ''}`}>
            <div className="image">
                <img src={QuestionImage} alt={question} />
            </div>
            <div className={`question-content flex ${more ? 'flex-align-start' : 'flex-align-center'} flex-between`}>
                <div className="left">
                    <div className="question mb-8">{question}</div>
                    {more && 
                        <div className={'mb-12'}>
                            {!seeImage ? 
                                <Button
                                    type='outlined'
                                    text={'See Captured Image'}
                                    icon={<Image01 size={20} color='#666666' className='mr-8' />}
                                    className={'mb-12'}
                                    onClick={seeCapturedImage}
                                /> :
                                <div className='captured-image'>
                                    <img src={`${image}`} alt="" />
                                </div>
                            }
                            {/* <div className="quiz-example">
                                <p className='mb-12'>Equations:</p>
                                <ul>
                                    <li>A. y=mx-b</li>
                                    <li>B. y=ax2+bx+c</li>
                                    <li>C. y=a/y</li>
                                </ul>
                            </div> */}
                        </div>
                    }
                    <div className="answer flex flex-align-center">
                        <span>Ai Answer</span>
                        <p>{answer}</p>
                    </div>
                </div>
                <div className="right flex flex-align-center">
                    <Button 
                        text={`${more ? 'See Less' : 'See More'}`} 
                        type="text"
                        className={'mr-12'}
                        onClick={handleSeeMore}
                    />
                    <Button
                        text={'Generate Quiz'} 
                        type='outlined' 
                        iconRight={
                            <ArrowUpRight color="#fff" size={20} className='ml-8' />
                        }
                        onClick={openGenerateYourQuizModal}
                    />
                </div>
            </div>
        </div>
    );
}

export default QuestionCard;